<template>
	<div class="m-lead">
		<div class="lead-intro">
			把想做的东西讲清楚，越具体我越好判断能不能接、要多久。看到后我会尽快回复。
		</div>

		<el-form ref="form" :model="form" label-position="top" size="small">
			<el-form-item label="需求标题">
				<el-input v-model="form.title" maxlength="50" show-word-limit placeholder="一句话说清要做什么"/>
			</el-form-item>

			<el-form-item label="项目类型">
				<el-radio-group v-model="form.projectType">
					<el-radio-button v-for="item in projectTypes" :key="item.value" :label="item.value">
						{{ item.label }}
					</el-radio-button>
				</el-radio-group>
			</el-form-item>

			<el-form-item label="需求描述">
				<el-input type="textarea" v-model="form.requirement" :rows="5" maxlength="1000" show-word-limit
				          placeholder="要实现哪些功能、有没有参考的产品、目前进展到哪一步" resize="vertical"/>
			</el-form-item>

			<el-form-item label="预算方式">
				<el-radio-group v-model="form.budgetType">
					<el-radio-button v-for="item in budgetTypes" :key="item.value" :label="item.value">
						{{ item.label }}
					</el-radio-button>
				</el-radio-group>
			</el-form-item>

			<el-form-item v-if="form.budgetType !== '2'" :label="`预算区间（元${form.budgetType === '1' ? '/时' : ''}）`">
				<div class="budget-range">
					<el-input-number v-model="form.budgetMin" :min="0" :step="100" :controls="false" placeholder="下限"/>
					<span class="budget-sep">至</span>
					<el-input-number v-model="form.budgetMax" :min="0" :step="100" :controls="false" placeholder="上限"/>
				</div>
			</el-form-item>

			<el-form-item label="期望交付时间">
				<el-date-picker v-model="form.deadline" type="date" placeholder="选择日期（可不填）"
				                value-format="yyyy-MM-dd" :picker-options="pickerOptions"/>
			</el-form-item>

			<el-form-item label="联系方式">
				<el-radio-group v-model="form.contactType" class="contact-types">
					<el-radio-button v-for="item in contactTypes" :key="item.value" :label="item.value">
						{{ item.label }}
					</el-radio-button>
				</el-radio-group>
				<el-input v-model="form.contact" :placeholder="contactPlaceholder" class="contact-input"/>
			</el-form-item>

			<el-checkbox v-model="agreed" class="lead-agree">
				我同意这些信息仅用于本次需求的沟通联系
			</el-checkbox>

			<div class="lead-submit">
				<el-button type="primary" :loading="submitting" @click="submit">提交需求</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	import {submitLead} from '@/api/wxtools'

	export default {
		name: 'LeadForm',
		data() {
			return {
				submitting: false,
				agreed: false,
				form: {
					title: '',
					projectType: 'website',
					requirement: '',
					budgetType: '0',
					budgetMin: undefined,
					budgetMax: undefined,
					deadline: '',
					contactType: 'wechat',
					contact: ''
				},
				projectTypes: [
					{label: '网站', value: 'website'},
					{label: '小程序', value: 'miniapp'},
					{label: '爬虫', value: 'spider'},
					{label: '自动化', value: 'automation'},
					{label: '其他', value: 'other'}
				],
				budgetTypes: [
					{label: '固定预算', value: '0'},
					{label: '按时计费', value: '1'},
					{label: '面议', value: '2'}
				],
				contactTypes: [
					{label: '微信', value: 'wechat'},
					{label: 'QQ', value: 'qq'},
					{label: '邮箱', value: 'email'},
					{label: '电话', value: 'phone'}
				],
				pickerOptions: {
					disabledDate: (date) => date.getTime() < Date.now() - 86400000
				}
			}
		},
		computed: {
			contactPlaceholder() {
				return {
					wechat: '请输入微信号',
					qq: '请输入 QQ 号',
					email: '请输入邮箱地址',
					phone: '请输入手机号'
				}[this.form.contactType] || '请输入联系方式'
			}
		},
		methods: {
			validate() {
				const form = this.form
				if (!form.title.trim()) return '请填写需求标题'
				if (!form.requirement.trim()) return '请描述一下需求内容'
				if (!form.contact.trim()) return '请留下联系方式，否则我无法联系到你'
				if (form.contactType === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.contact.trim())) {
					return '邮箱格式看起来不太对'
				}
				if (form.contactType === 'phone' && !/^1[3-9]\d{9}$/.test(form.contact.trim())) {
					return '手机号格式看起来不太对'
				}
				if (form.budgetType !== '2' && form.budgetMin && form.budgetMax
					&& Number(form.budgetMin) > Number(form.budgetMax)) {
					return '预算下限不能高于上限'
				}
				if (!this.agreed) return '请先阅读并同意信息使用说明'
				return ''
			},
			submit() {
				const message = this.validate()
				if (message) {
					this.$message.warning(message)
					return
				}

				const form = this.form
				const noBudget = form.budgetType === '2'
				this.submitting = true
				submitLead({
					title: form.title.trim(),
					projectType: form.projectType,
					requirement: form.requirement.trim(),
					budgetType: form.budgetType,
					budgetMin: noBudget || !form.budgetMin ? null : Number(form.budgetMin),
					budgetMax: noBudget || !form.budgetMax ? null : Number(form.budgetMax),
					deadline: form.deadline || null,
					contactType: form.contactType,
					contact: form.contact.trim()
				}).then((res) => {
					if (res.code === 200) {
						this.$alert(res.msg || '我会尽快与你联系', '提交成功', {confirmButtonText: '好的'})
						this.reset()
					} else {
						this.$message.error(res.msg || '提交失败')
					}
				}).catch(() => {
					this.$message.error('提交失败，稍后再试')
				}).finally(() => {
					this.submitting = false
				})
			},
			reset() {
				this.form.title = ''
				this.form.requirement = ''
				this.form.budgetMin = undefined
				this.form.budgetMax = undefined
				this.form.deadline = ''
				this.form.contact = ''
				this.agreed = false
			}
		}
	}
</script>

<style scoped>
	.lead-intro {
		font-size: 13px;
		line-height: 1.7;
		color: rgba(0, 0, 0, .6);
		padding: 12px 14px;
		background: rgba(64, 158, 255, .06);
		border-radius: 6px;
		margin-bottom: 18px;
	}

	.budget-range {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.budget-sep {
		color: rgba(0, 0, 0, .4);
		font-size: 13px;
	}

	.contact-types {
		display: block;
		margin-bottom: 8px;
	}

	.contact-input {
		max-width: 280px;
	}

	.lead-agree {
		font-size: 12px;
	}

	.lead-agree >>> .el-checkbox__label {
		font-size: 12px;
		color: rgba(0, 0, 0, .5);
	}

	.lead-submit {
		margin-top: 16px;
	}

	.m-lead >>> .el-form-item__label {
		padding-bottom: 2px;
		font-size: 13px;
		color: rgba(0, 0, 0, .7);
	}

	.m-lead >>> .el-input-number {
		width: 120px;
	}

	.m-lead >>> .el-input-number .el-input__inner {
		text-align: left;
	}
</style>
